import {
  TypographyElement,
  Row,
  IconButton,
  Icons
} from 'UI'
import classNames from 'classnames'
import { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import Text from './text.json'
import { chunk } from 'lodash'

const useStyles = createUseStyles(style)
const swipingDistance = 5

const views = (
  view,
  learningPathProjects,
  setSelectedProject,
  setSelectedImage,
  setShowPopUp,
  selectedProject,
  selectedProjectStyle,
  cardStyle,
  image
) => {
  const theme = useTheme()
  const splicedProjectDetails = chunk(learningPathProjects, 6)
  return splicedProjectDetails.map((item, index) => (
    <div key={index} className={view}>
      {item.map((project, key) => (
        <div key={key} className={cardStyle}>
          <TypographyElement variant='caption' color={theme.neutral[0]}>
            {Text.project} {index * 6 + key + 1}
          </TypographyElement>
          <img
            key={project.CourseId}
            src={project.ProjectImages[0].SmallImageLink}
            alt={project.ProjectImages[0].Text}
            height={86}
            width={153}
            className={classNames(
              image,
              project.CourseId === selectedProject.CourseId
                ? selectedProjectStyle
                : ''
            )}
            onClick={() => {
              setSelectedProject(project)
              setSelectedImage(project.ProjectImages[0])
              setShowPopUp(true)
            }}
          />
        </div>
      ))}
    </div>
  ))
}

export default ({
  setShowPopUp,
  projectDetails,
  selectedImage,
  setSelectedImage,
  selectedProject,
  setSelectedProject,
  isLearningPath,
  learningPathProjects,
  isMobile,
  handlePreviousImage,
  handleNextImage,
  handleImageClick,
  imagesArray
}) => {
  const {
    image,
    selectedImageStyle,
    view,
    cardStyle,
    bigImage,
    selectedProjectStyle,
    responsiveCard,
    responsiveRow,
    dots,
    dot,
    selectedDot,
    imagesContainer,
    imagesWrapper,
    arrowsContainer,
    buttonStyle,
    imageAndArrows,
    tags
  } = useStyles({ isMobile })

  const [touchPosition, setTouchPosition] = useState(null)
  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX
    setTouchPosition(touchDown)
  }
  const handleTouchMove = (e) => {
    const touchDown = touchPosition
    if (touchDown === null) {
      return
    }
    const currentTouch = e.touches[0].clientX
    const diff = touchDown - currentTouch
    if (diff > swipingDistance) {
      handleNextImage()
    }
    if (diff < -swipingDistance) {
      handlePreviousImage()
    }
    setTouchPosition(null)
  }
  const showGalleryArrows = imagesArray?.length > 1

  const altImage = `${selectedImage?.Text} ${tags}`
  return (
    <div className={imagesContainer}>
      <div className={imagesWrapper}>
        <div className={imageAndArrows}>
          {showGalleryArrows && (
            <div className={arrowsContainer}>
              <IconButton
                iconName={Icons.roundedLeft}
                className={buttonStyle}
                onHandleClick={handlePreviousImage}
              />
              <IconButton
                iconName={Icons.roundedRight}
                className={buttonStyle}
                onHandleClick={handleNextImage}
              />
            </div>
          )}
          <img
            src={selectedImage?.LargeImageLink}
            alt={altImage}
            width='100%'
            className={bigImage}
            onTouchStart={isLearningPath && handleTouchStart}
            onTouchMove={isLearningPath && handleTouchMove}
          />
        </div>

        {
          isLearningPath && (
            <div className={dots}>
              {imagesArray?.map((project, index) => (
                <div
                  key={project.ImageId}
                  className={classNames(dot, { [selectedDot]: project.ImageId === selectedImage?.ImageId })}
                  onClick={() => handleImageClick(project)}
                />
              ))}
            </div>)
          }
        <Row className={responsiveRow}>
          {isLearningPath
            ? views(
                view,
                learningPathProjects,
                setSelectedProject,
                setSelectedImage,
                setShowPopUp,
                selectedProject,
                selectedProjectStyle,
                cardStyle,
                image)
            : projectDetails.map(project => (
              <div key={project.Id} className={responsiveCard}>
                <img
                  key={project.ImageId}
                  src={project.SmallImageLink}
                  alt={project.Text}
                  height={70}
                  width={120}
                  className={classNames(image, { [selectedImageStyle]: project.ImageId === selectedImage?.ImageId })}
                  onClick={() => {
                    setSelectedImage(project)
                    setShowPopUp(true)
                  }}
                />
              </div>
            ))}
        </Row>
      </div>
    </div>
  )
}
